import { ISelect, Locales } from '../../common/interfaces';
import { Messages, MessagesByLocaleType } from './LocaleProvider.interfaces';

export const selectAppLangOptions: ISelect[] = [
  { label: 'RU', value: Locales.RU },
  { label: 'EN', value: Locales.ENG },
];

export const messages: MessagesByLocaleType = {
  [Locales.RU]: {
    [Messages.CANCEL]: 'Отмена',
    [Messages.SAVE]: 'Сохранить',
    [Messages.FILTER_DATE]: 'Дата',
    [Messages.RELOAD]: 'Обновить',
    [Messages.PAGE_NOT_FOUND_MESSAGE]:
      '404. Запрашиваемая вами страница не найдена.',
    [Messages.LOGOUT]: 'Выйти',
  },

  [Locales.ENG]: {
    [Messages.CANCEL]: 'Cancel',
    [Messages.SAVE]: 'Save',
    [Messages.FILTER_DATE]: 'Date',
    [Messages.RELOAD]: 'Reload',
    [Messages.PAGE_NOT_FOUND_MESSAGE]: '404. Page not found.',
    [Messages.LOGOUT]: 'Logout',
  },
};
